import { ReactNode, useEffect, useState } from "react";
import { ReactComponent as LockIcon } from "../assets/graphics/lock.svg";

export interface RankTitleTickedProps {
  playerLevel: number;
  rank: number;
  title: string;
  ticked: ReactNode;
}

const LevelsRankTitleTicked: React.FC<RankTitleTickedProps> = ({
  playerLevel,
  rank,
  title,
  ticked
}) => {
  const [rankTickStatus, setRankTickStatus] = useState(false);
  const [rankColorActive, SetColorActive] = useState("bg-grey");
  const [rankTextActive, SetTextActive] = useState("");

  useEffect(() => {
    if (playerLevel >= rank) {
      setRankTickStatus(true);

      if (playerLevel >= 1 && rank < 6) {
        SetColorActive("bg-statusblue");
        SetTextActive("text-statusblue");
      } else if (playerLevel >= 6 && rank < 11) {
        SetColorActive("bg-statusgreen");
        SetTextActive("text-statusgreen");
      } else if (playerLevel >= 11) {
        SetColorActive("bg-statusyellow");
        SetTextActive("text-statusyellow");
      }
    }
  }, [playerLevel, rank]);

  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center">
        <div
          className={`${rankColorActive} w-8 h-6 rounded-md flex items-center justify-center mb-1 mr-0.5`}
        >
          <span className="text-s font-semibold text-black">{rank}</span>
        </div>
        <span className={`ml-1 ${rankTextActive} `}>{title}</span>
      </div>
      <div className="pr-3">{rankTickStatus ? ticked : <LockIcon />}</div>
    </div>
  );
};

export default LevelsRankTitleTicked;
